import Cookies from 'js-cookie';
import { useState, useEffect } from 'react';

import { useConfig } from '../providers';

interface GetCookieOptions {
  retryInterval: number;
  maxRetries: number;
}

export function useGetCookie(cookieName: string, options?: GetCookieOptions) {
  const { retryInterval = 1000, maxRetries = 10 } = options ?? {};

  const { examRoomMode } = useConfig();
  const [cookieValue, setCookieValue] = useState<string | undefined>(() => {
    return Cookies.get(cookieName);
  });

  useEffect(() => {
    if (examRoomMode === 'preview') return;
    if (cookieValue) return;

    let timeoutId: NodeJS.Timeout;
    let retryCount = 0;

    const checkCookie = () => {
      const value = Cookies.get(cookieName);

      if (value) {
        setCookieValue(value);
      } else if (retryCount < maxRetries) {
        retryCount++;
        console.error(`Attempt No. ${retryCount}, Cookie not found by name: ${cookieName}`);
        timeoutId = setTimeout(checkCookie, retryInterval);
      } else {
        console.error(`Max retries reached for cookie: ${cookieName}`);
        // NOTE: We set cookie value as undefined here for explicitness
        setCookieValue(undefined);
      }
    };

    if (!cookieValue) {
      checkCookie();
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [cookieName, retryInterval, maxRetries]);

  return cookieValue;
}
